module.exports = __webpack_public_path__ + "img/paySuccess.4fb5bcc3.png";